<template>
	<div class="kActionbar">
		<el-form ref="form" :model="form" :rules="rules.form" label-width="120px" size="mini" label-position="top">
			<div class="formTitle">
				<div class="label">
					<span>审批意见(可不填)</span>
					<p>确认即同意，不同意就退回</p>
				</div>
			</div>
			<el-form-item>
				<el-input type="textarea" v-model="form.check_content"></el-input>
				<div class="tips">(审批意见可以填写理由，为什么同意？为什么不同意？不想说理由可以不写)</div>
			</el-form-item>
			<div style="display: flex;">
				<!--开票申请9和红冲申请19需填写发票-->
				<!-- || actioninfo.step_info.set_id == 19 -->
				<div class="formTitle"
					v-if="((actioninfo.step_info.set_id == 9 && actioninfo.title_info && actioninfo.title_info.is_placeholder && actioninfo.title_info.is_placeholder == 1) || (actioninfo.title_info && actioninfo.title_info.is_hongc && actioninfo.title_info.is_hongc == 1 && actioninfo.step_info.set_id == 19)) && !nextStepvisible">
					<div class="label">发票</div>
					<div class="input">
						<el-form-item prop="invioce_lr_id">
							<el-input v-model="form.invioce_lr_id" clearable placeholder="请输入发票号" style="width: 600px;"
								show-word-limit></el-input>
						</el-form-item>
					</div>
				</div>
				<!--退款申请需填写-->
				<div class="formTitle" v-if="actioninfo.step_info.set_id == 18 && !nextStepvisible">
					<div class="label">银行流水</div>
					<div class="input">
						<el-form-item prop="bank_transaction_number">
							<el-input v-model="form.bank_transaction_number" clearable placeholder="请输入银行流水号" style="width: 600px;"
								show-word-limit></el-input>
							<!-- <span style="margin-left: 10px;">(请填写银行流水号，以英文逗号隔开。例:C0446TU00177HOZ,C0446TU00177HOZ)</span> -->
						</el-form-item>
					</div>
				</div>
				<div class="formTitle" v-if="nextStepvisible">
					<div class="label">将提交给</div>
					<div class="input">
						<el-form-item>
							<el-input v-model="actioninfo.step_info.next_step.step_name" disabled></el-input>
						</el-form-item>
					</div>
				</div>
			</div>
			<!--开票申请9上传发票附件-->
			<div class="formTitle"
				v-if="actioninfo.step_info.set_id == 9 && actioninfo.title_info && actioninfo.title_info.is_placeholder && actioninfo.title_info.is_placeholder == 1 && !nextStepvisible"
				style="margin-top: 20px; align-items: start; height: 150px;">
				<div class="label">电子发票</div>
				<div class="input" style="margin-top: 5px;">
					<el-form-item prop="attachments">
						<el-upload action accept=".pdf,.ofd,.xml" :file-list="form.attachments"
							:on-remove="(file) => handleRemoveUpload(file, 'form', 'attachments', false)" :auto-upload="false"
							:on-change="(file) => changeRequired(file, 'form', 'attachments', false)" :on-preview="viewImg"
							:on-exceed="limitMessage" multiple :limit="3">
							<el-button slot="trigger" size="mini">选取文件</el-button>
						</el-upload>
					</el-form-item>
				</div>
			</div>
			<div class="btn">
				<el-button @click="actionGo(item)" :type="item.id == 3 ? 'danger' : 'primary'" v-if="item.status == 'true'"
					v-for="(item, index) in actioninfo.step_info.button_list" :key="index"
					:disabled="disabledButtons[item.id] === true">{{ item.name }}</el-button>
				<el-button @click="goback()">返回</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
export default {
	name: 'actionbar',
	props: ['actioninfo'],
	data () {
		return {
			form: {
				check_content: '',
				invioce_lr_id: '',
				bank_transaction_number: '',
				attachments: []
			},
			nextStepvisible: false,
			disabledButtons: {},
			rules: {
				form: {
					'invioce_lr_id': [
						{ required: true, message: '请填写发票号！', trigger: ['change'] }
					],
					'bank_transaction_number': [
						{ required: true, message: '请填写银行流水号，以逗号隔开！', trigger: ['change'] },
						{
							validator: (rule, value, callback) => {
								if (!value) {
									callback(new Error('请填写银行流水号'));
								}
								// else if(value){
								// 	this.$api.post('/admin/customers/customer/checkbanktransactionnumber',{bank_transaction_number:value}).then(res => {
								// 		  if (res.code === 0) {
								// 			  callback();
								// 		  } else {
								// 			callback(new Error(res.msg));
								// 		  }
								// 	})
								// }
								else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'attachments': [
						{
							required: true, validator: (rule, value, callback) => {
								if (this.form.attachments.length < 1) {
									callback(new Error('请上传电子发票！'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					]
				},
			}
		}
	},
	mounted: function () {
		if (Object.keys(this.actioninfo.step_info.next_step).length === 0 && this.actioninfo.step_info.next_step.constructor === Object) {
			this.nextStepvisible = false
		} else {
			this.nextStepvisible = true
		}
		this.$nextTick(() => {
			this.$refs['form'].clearValidate();
		});
	},
	methods: {
		//返回
		goback () {
			window.history.back()
		},
		//点击查看大图
		viewImg (file) {
			if (!file.path) {
				//还未上传
				let url = URL.createObjectURL(file)
				if (file.name.includes('.jpg') || file.name.includes('.jpeg') || file.name.includes('.png')) {
					this.dialogImageUrl = url;
					this.dialogVisibleImg = true;
				} else {
					window.open(url)
				}
			} else {
				//已上传
				if (file.name.includes('.jpg') || file.name.includes('.jpeg') || file.name.includes('.png')) {
					this.dialogImageUrl = file.path;
					this.dialogVisibleImg = true;
				} else {
					window.open(file.path)
				}
			}
		},
		//上传图片
		changeRequired (file, formobj, field, limitOne = true) {
			if (limitOne) {
				this[formobj][field] = [file.raw]
			} else {
				this[formobj][field].push(file.raw)
			}
		},
		//移除图片
		handleRemoveUpload (file, formobj, field, limitOne = true) {
			if (limitOne) {
				this[formobj][field] = []
			} else {
				this[formobj][field].forEach(function (item, index) {
					if (item.name == file.name) {
						this.$delete(this[formobj][field], index)
					}
				}.bind(this))
			}

		},
		limitMessage: function (files, fileList) {
			console.log(files);
			console.log(fileList)
			this.$message({
				showClose: true,
				message: `本次选择了 ${fileList.length} 个文件,超出最大要求数量限制`,
				type: 'warning'
			})
		},
		//操作按钮
		actionGo (item) {
			this.$set(this.disabledButtons, item.id, true)
			if (item.id == 1) {
				//确认下一步
				this.nextstep(item.id)
			} else if (item.id == 2) {
				//"退回上一步"
				this.prevstep(item.id)
			} else if (item.id == 3) {
				//"退回到发起人"
				this.prestartvstep(item.id)
			} else if (item.id == 4) {
				//"结束该进程"
				this.endstep(item.id)
			}
		},
		nextstep (buttonId) {
			let params = {}
			params.data_id = this.actioninfo.step_info.data_id
			params.log_id = this.actioninfo.step_info.log_id
			params.check_content = this.form.check_content
			params.next_step_id = this.actioninfo.step_info.next_step.id
			this.$emit('update:loading', true)
			this.$api.post('/admin/examine/approve/nextstep', params).then(res => {
				this.$set(this.disabledButtons, buttonId, false)
				if (res.code === 0) {
					this.$message({
						showClose: true,
						message: '审批成功！',
						type: 'success',
						onClose: () => {
							window.history.back()
						}
					});
				} else {
					this.$message.error(res.msg);
					this.$emit('update:loading', false)
				}
			}).catch(() => {
				this.$set(this.disabledButtons, buttonId, false)
				this.$emit('update:loading', false)
			})
		},
		prevstep (buttonId) {
			this.$confirm('确定将该流程退回上一步吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				let params = {}
				params.data_id = this.actioninfo.step_info.data_id
				params.log_id = this.actioninfo.step_info.log_id
				params.check_content = this.form.check_content
				this.$emit('update:loading', true)
				this.$api.post('/admin/examine/approve/prevstep', params).then(res => {
					this.$set(this.disabledButtons, buttonId, false)
					if (res.code === 0) {
						this.$message({
							showClose: true,
							message: '审批成功！',
							type: 'success',
							duration: 1000,
							onClose: () => {
								window.history.back()
							}
						});
					} else {
						this.$message.error(res.msg);
						this.$emit('update:loading', false)
					}
				}).catch(() => {
					this.$set(this.disabledButtons, buttonId, false)
					this.$emit('update:loading', false)
				})
			}.bind(this)).catch(() => {
				this.$set(this.disabledButtons, buttonId, false)
			})
		},
		prestartvstep (buttonId) {
			this.$confirm('确定将该流程退回发起人吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				let params = {}
				params.data_id = this.actioninfo.step_info.data_id
				params.log_id = this.actioninfo.step_info.log_id
				params.check_content = this.form.check_content
				this.$emit('update:loading', true)
				this.$api.post('/admin/examine/approve/prestartvstep', params).then(res => {
					this.$set(this.disabledButtons, buttonId, false)
					if (res.code === 0) {
						this.$message({
							showClose: true,
							message: '审批成功！',
							type: 'success',
							onClose: () => {
								window.history.back()
							}
						});
					} else {
						this.$message.error(res.msg);
						this.$emit('update:loading', false)
					}
				}).catch(() => {
					this.$set(this.disabledButtons, buttonId, false)
					this.$emit('update:loading', false)
				})
			}.bind(this)).catch(() => {
				this.$set(this.disabledButtons, buttonId, false)
			})
		},
		endstep (buttonId) {
			this.$refs['form'].validate(function (valid) {
				if (valid) {
					this.$confirm('确定结束该流程吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(function () {
						let params = {}
						params.data_id = this.actioninfo.step_info.data_id
						params.log_id = this.actioninfo.step_info.log_id
						params.check_content = this.form.check_content
						if (this.actioninfo.step_info.set_id == 9) {
							//开票申请
							params.invioce_lr_id = this.form.invioce_lr_id
							params.attachments = this.form.attachments
						} else if (this.actioninfo.step_info.set_id == 19) {
							//红冲申请
							params.invioce_lr_id = this.form.invioce_lr_id
						} else if ((this.actioninfo.step_info.set_id == 16 && this.actioninfo.title_info.is_order != 1) || this.actioninfo.step_info.set_id == 18) {
							//退款申请
							params.bank_transaction_number = this.form.bank_transaction_number
						}
						const formData = new FormData()
						for (const key in this.form) {
							if (key == 'attachments') {
								if (this.form[key].length > 0) {
									this.form[key].forEach(item => {
										formData.append(key, item)
									})
								} else {
									formData.append(key, '')
								}
							} else {
								formData.append(key, this.form[key]);
							}
						}
						formData.append('data_id', this.actioninfo.step_info.data_id);
						formData.append('log_id', this.actioninfo.step_info.log_id);
						this.$emit('update:loading', true)
						this.$api.post('/admin/examine/approve/endstep', formData).then(res => {
							this.$set(this.disabledButtons, buttonId, false)
							if (res.code === 0) {
								this.$message({
									showClose: true,
									message: '审批成功！',
									type: 'success',
									onClose: () => {
										window.history.back()
									}
								});
							} else {
								this.$message.error(res.msg);
								this.$emit('update:loading', false)
							}
						}).catch(() => {
							this.$set(this.disabledButtons, buttonId, false)
							this.$emit('update:loading', false)
						})
					}.bind(this)).catch(() => {
						this.$set(this.disabledButtons, buttonId, false)
					})
				} else {
					this.$set(this.disabledButtons, buttonId, false)
					if (this.actioninfo.step_info.set_id == 9 || (this.actioninfo.title_info && this.actioninfo.title_info.is_hongc && this.actioninfo.title_info.is_hongc == 1 && this.actioninfo.step_info.set_id == 19)) {
						this.$message.error("请填写正确的信息！");
					} else if ((this.actioninfo.step_info.set_id == 16 && this.actioninfo.title_info.is_order != 1) || this.actioninfo.step_info.set_id == 18) {
						this.$message.error("请填写正确的银行流水号！");
					}
				}
			}.bind(this));
		}
	}
}
</script>
<style scoped lang="scss">
.kActionbar {
	background-color: #fff;
	border-radius: 8px 8px 0 0;
	margin-top: 20px;
	padding: 12px 24px 24px;

	.formTitle {
		display: flex;
		align-items: center;
		padding-right: 20px;

		.label {
			display: flex;
			align-items: center;
			height: 18px;
			font-weight: 700;
			font-size: 14px;
			padding: 10px 0;
			margin-right: 10px;

			span {
				margin-right: 10px;
			}

			p {
				font-weight: 500;
				font-size: 12px;
				color: #FF0200;
			}

			&:before {
				content: "";
				display: inline-block;
				width: 3px;
				border-radius: 15px;
				height: 100%;
				margin-right: 6px;
				background-color: #409EFF;
			}
		}

		.input {
			display: flex;
			align-items: center;

			.el-form-item--mini.el-form-item,
			.el-form-item--small.el-form-item {
				margin-bottom: 0;
			}
		}
	}

	.tips {
		font-weight: normal;
		font-size: 12px;
		color: #FF0200;
	}

	.btn {
		display: flex;
		justify-content: center;
		margin-top: 20px;

		.el-button {
			width: 246px;
			height: 38px;
			display: inline-flex;
			align-items: center;
			justify-content: center;
		}
	}
}
</style>
